import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { HeaderDataProps } from '../../components/navigation/header/Header';
import { SecondaryHeaderDataProps } from '../../components/navigation/header/secondaryHeader/SecondaryHeader';
import { AMPPrimaryHeader } from './AMPPrimaryHeader';
import { AMPSideBar } from './AMPSideBar';
import { AMPSecondaryHeader } from './AMPSecondaryHeader';
import { PrimaryHeaderDataProps } from '../../components/navigation/header/primaryHeader/PrimaryHeader';

interface AMPHeaderProps {
    primaryHeader: PrimaryHeaderDataProps;
    secondaryHeader: SecondaryHeaderDataProps | null;
    shouldShowClosedMenuIcon: boolean;
}

const getHeaderStyle = () => StyleSheet.create({
  wrapper: {
    position: 'fixed',
    width: '100%',
    zIndex: 1500,
    top: 0,
  },
});

export const AMPHeader: React.FunctionComponent<AMPHeaderProps> = props => {
  const { primaryHeader, shouldShowClosedMenuIcon, secondaryHeader } = props;
  const { links, logo, cta, editions, editionEndpoint, pagePath } = primaryHeader;
  const style = getHeaderStyle();
  return (
    <header className={css(style.wrapper)}>
      <AMPPrimaryHeader links={links} logo={logo} cta={cta} shouldShowClosedMenuIcon={shouldShowClosedMenuIcon} editions={editions} pagePath={pagePath} editionEndpoint={editionEndpoint} />
      {secondaryHeader ? <AMPSecondaryHeader {...secondaryHeader} pagePath={pagePath} /> : null}
    </header>
  );
};


export const AMPHeaderAndSideBar: React.FunctionComponent<HeaderDataProps> = props => {
  const { secondaryHeader, primaryHeader } = props;
  const { editions, menu, editionEndpoint } = primaryHeader;
  return (
    <React.Fragment>
      <AMPHeader primaryHeader={primaryHeader} secondaryHeader={secondaryHeader} shouldShowClosedMenuIcon={!!menu} />
      { menu ? <AMPSideBar menu={menu} editions={editions} editionEndpoint={editionEndpoint} /> : null}
    </React.Fragment>
  );
};
